<template>
  <v-layout>
    <v-dialog
      persistent
      v-model="dialog"
      max-width="700px"
      @click:outside="handleClose"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{
            importing ? 'Import a Project' : 'Create a Project'
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="!importing">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="importing">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="fileToImportName"
                  label="File to Import"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="handleClose">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="handleUpload"
            v-if="!importing"
            >Upload</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="handleImport"
            v-if="importing"
            :loading="importInProgress"
            >Import</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="save"
            v-if="!importing && canAddProject"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <component
      ref="uploadDialogForm"
      :show-dialog="uploadDialogVisible"
      :is="uploadDialogComponent"
      @done="uploadDialogOnDone"
      @cancel="uploadDialogOnCancel"
    ></component>
    <v-dialog v-model="importInProgress" persistent width="300">
      <v-card dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Enums from '@/helpers/Enums'
import UploadDialog from '@/components/UploadDialog'
import ProjectsService from '@/services/ProjectsService'
export default {
  name: 'NewProjectDialog',
  components: {
    UploadDialog
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    editedItem: {
      type: Object,
      required: false,
      default: function() {
        return {
          name: 'New Project Name',
          isSuperAdmin: false
        }
      }
    }
  },
  computed: {
    fileToImportName() {
      if (this.tempImportData !== null) {
        return this.tempImportData.name
      } else {
        return ''
      }
    },
    canAddProject() {
      if (
        this.$store.state.UserStore.userRole[0] === 'project_admin' ||
        this.$store.state.UserStore.userRole[0] === 'super_admin'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    isVisible: function(newValue) {
      this.dialog = newValue
    },
    editedItem: function(newMedia, oldVal) {}
  },
  data() {
    return {
      dialog: false,
      uploadDialogVisible: false,
      tempImportData: null,
      importing: false,
      uploadDialogComponent: null,
      importInProgress: false
      //canAddProject: false
    }
  },
  methods: {
    handleClose(e) {
      this.importing = false
      this.dialog = false
      this.$emit('onClose')
    },
    async save() {
      if (this.$store.state.UserStore.userRole.includes('super_admin')) {
        this.editedItem.isSuperAdmin = true
      } else {
        this.editedItem.isSuperAdmin = false
      }
      await this.$store.dispatch('ProjectStore/createProject', this.editedItem)
      this.$emit('onClose')
    },
    async handleImport() {
      try {
        this.importInProgress = true
        let result = await ProjectsService.importProject({
          tempFileName: this.tempImportData.tempName
        })
        console.log('import result:', result)
        this.importInProgress = false
        this.$store.dispatch(
          'NotificationStore/add',
          { type: 'success', message: `Import successful` },
          { root: true }
        )
        this.handleClose()
      } catch (e) {
        this.importInProgress = false
        this.$store.dispatch(
          'NotificationStore/add',
          { type: 'error', message: `Error importing file, unable to import` },
          { root: true }
        )
      }
    },
    async uploadDialogOnDone(newValue) {
      console.log('uploadDialogOnDone', newValue)
      this.uploadDialogVisible = false
      this.$nextTick(function() {
        this.uploadDialogComponent = null
      })
      if (
        newValue.data &&
        Array.isArray(newValue.data) &&
        newValue.data.length > 0
      ) {
        if (newValue.data.length > 1) {
          console.warn('Uploaded more than one file, not implemented yet :-(')
        }
        this.tempImportData = newValue.data[0]
      }
    },
    uploadDialogOnCancel() {
      this.uploadDialogVisible = false
      this.importing = false
      this.$nextTick(function() {
        this.uploadDialogComponent = null
      })
    },
    handleUpload() {
      this.uploadDialogComponent = UploadDialog
      let self = this
      this.$nextTick(function() {
        this.uploadDialogVisible = true
        this.importing = true
      })
    }
  }
}
</script>

<style scoped></style>
